<div class="border" [class.clickable]="clickable">
  <ng-content></ng-content>
</div>
